<template>
  <div class="supplier-quotes-rfq2__list-rfq-2">
    <list-form ref="list-form" :config="config" :formModel="formModel" :customDelete="handlerDelete">
      <template v-slot:title="{ title }">
        <h3 class="blue-text">{{title}}</h3>
      </template>
      <template v-slot="{ data, updateDataItem, updateModelItem, handleCommand }">
        <edit-form
          :config="{ id: config.id }"
          :data="data"
          :model="formModel"
          @change="updateDataItem($event)"
          @updateModelItem="updateModelItem"
          @command="handleCommand"
        />
      </template>
    </list-form>
    <modal-new
      :config="{ id: config.id }"
      :dataRFQ2="modalData"
      @on-added-items="refresh"
    />
    <dialog-confirm
      ref="dialogConfirm"
      :config="{
        title: this.L10n('confirm-duplicate-add-supplier'),
        msgTemplate: this.messageTemplate,
      }"
      @cancel="onCancelConfirmAddToSupplier"
      @confirm="onConfirmConfirmAddToSupplier"
    >
      <template v-slot:footer-confirm="{ clickHandler }">
        <el-button
          type="info"
          size="medium"
          plain
          @click.prevent="clickHandler('cancel')">
          {{L10n('cancel')}}
        </el-button>
        <el-button
          type="danger"
          size="medium"
          @click.prevent="clickHandler('confirm')">
          {{L10n('confirm')}}
        </el-button>
      </template>
    </dialog-confirm>
  </div>
</template>

<script>
import listFormConfig from './ListFormConfig.json'
import { waitValue } from '@/utils/promises.js'
import { ServiceRepairExchangeOrderFollowUp } from '@/services/RepairExchangeOrderFollowUp'
import { getDefaultOrderPhaseID, getDefaultRFQID } from '@/utils/shared'
import { ModelRFQ2s } from '@/services/RFQ2s'
import { api } from '@/services/api'
export default {
  name: 'SectionRFQ2',
  components: {
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index'),
    'modal-new': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './ModalNew'),
    'edit-form': () => import(/* webpackChunkName: 'SupplierPoRFQ2' */ './FormRFQ2.vue'),
    'dialog-confirm': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogConfirm')
  },
  props: {
    data: { type: Object },
    supplierCompanyID: { required: true },
    baxpo: { required: true }
  },
  created () {
    this.$bus.$on('print-proforma-supplier', this.updateRepairExhangeFollowup)
    this.$bus.$on('add-to-support-po-followup', this.addToSupportPoFollowUp)
  },
  beforeDestroy () {
    this.$bus.$off('print-proforma-supplier', this.updateRepairExhangeFollowup)
    this.$bus.$off('add-to-support-po-followup', this.addToSupportPoFollowUp)
  },
  watch: {
    watcher: {
      immediate: true,
      handler () {
        let { rfqid } = this.data || {}
        let supplierCompanyID = this.supplierCompanyID
        if (!rfqid || !supplierCompanyID) return
        this._getListForm()
          .then((listForm) => {
            let filters = `(rfqid == "${rfqid}" && supplierCompanyID == ${supplierCompanyID})`
            listForm.setFilters(filters)
            listForm.loadData()
          })
      }
    }
  },
  data () {
    return {
      config: listFormConfig
    }
  },
  computed: {
    watcher () {
      let { rfqid } = this.data || {}
      let supplierCompanyID = this.supplierCompanyID
      return `${rfqid}__${supplierCompanyID}`
    },
    modalData () {
      return { ...this.data, supplierCompanyID: this.supplierCompanyID }
    }
  },
  methods: {
    _getListForm () {
      return waitValue(() => this.$refs['list-form'])
    },
    formModel () {
      return new ModelRFQ2s()
    },
    onCancelConfirmAddToSupplier (data, confirmCallback) {
      confirmCallback(false)
    },
    onConfirmConfirmAddToSupplier (data, confirmCallback) {
      confirmCallback(true)
    },
    messageTemplate (data) {
      const title = [data.partNumber, data.partSN, data.baxpo, data.rfqid].map((item) => (item || '__')).join(' / ')
      return `${this.L10n('are-you-sure-duplicate')}: ${title}`
    },
    refresh () {
      return this._getListForm()
        .then((listForm) => {
          return listForm.refresh()
        })
    },
    handlerDelete (data) {
      let listForm = null
      return this._getListForm()
        .then((LF) => {
          listForm = LF
          listForm.isLoading = true
          return listForm
        })
        .then(() => {
          return this.requestChangeChosenRFQ2(data)
        })
        .then(() => {
          return this.getDeletingRFQ1(data)
        })
        .then((listOfRfq1) => {
          return Promise.all(listOfRfq1.map((dataRFQ1) => {
            return this.requestDeleteRFQ1(dataRFQ1)
          }))
        })
        .then(() => {
          return this.refresh()
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          if (listForm) {
            listForm.isLoading = false
          }
        })
    },
    requestChangeChosenRFQ2 (data) {
      let { url } = this.config.store.patch
      let requestData = {
        id: data.id,
        chosen: false,
        rfqid: getDefaultRFQID()
      }
      return api
        .patch(this.checkEs6AndRun(url, data), requestData)
    },
    updateRepairExhangeFollowup (data) {
      this._getListForm()
        .then((listForm) => {
          const data = listForm.getData()
          const dataWithChosen = data.filter(({ chosen }) => chosen)

          if (dataWithChosen.length === 0) {
            return Promise.resolve()
          }

          const filter = dataWithChosen.map(({ id }) => `rfQ2ID == ${id}`).join(' || ')

          listForm.isLoading = true

          return ServiceRepairExchangeOrderFollowUp
            .getAllDynamic({ filter })
            .then(({ data }) => {
              return Promise.all(data.value.map((itemRepair) => {
                const _data = {
                  id: itemRepair.id,
                  shipped: true,
                  shippedDate: new Date()
                }
                return ServiceRepairExchangeOrderFollowUp.patch(_data)
              }))
            })
            .catch((e) => {
              this.requestErrorHandler(e)
            })
            .finally(() => {
              listForm.isLoading = false
            })
        })
    },
    async addToSupportPoFollowUp (payload) {
      const listForm = await this._getListForm()
      const data = listForm.getData()
      const dataWithChosen = data.filter(({ chosen }) => chosen)

      this.$emit('onSetLoading', true)

      let promise = Promise.resolve()

      dataWithChosen
        .forEach((rfq2Item) => {
          const { id, partID, partSN } = rfq2Item
          const dataToSave = {
            orderPhaseID: getDefaultOrderPhaseID(),
            phaseDate: new Date(),
            rfQ2ID: id,
            partID,
            partSN,
            baxpo: this.baxpo,
            ...payload
          }
          promise = promise
            .then(() => {
              return ServiceRepairExchangeOrderFollowUp
                .createFromExistingOrder(dataToSave)
            })
            .then(this.requestSuccessHandler)
            .catch((e) => {
              let message = this.globalMixinErrorResponse(e)
              if (message === 'already-exist' && this.$store.getters.isHighPermission) {
                return new Promise((resolve, reject) => {
                  this.$refs['dialogConfirm']
                    .show({ ...dataToSave, ...rfq2Item }, (result) => {
                      if (result === true) {
                        resolve()
                      } else {
                        reject(new Error('asd'))
                      }
                    })
                })
                  .then(() => {
                    return ServiceRepairExchangeOrderFollowUp
                      .post(dataToSave)
                      .then(this.requestSuccessHandler)
                      .catch(this.requestErrorHandler)
                  })
                  .catch(() => 'ok')
              }
              return this.requestErrorHandler(e)
            })
        })
      promise
        .finally(() => {
          this.$emit('onSetLoading', false)
        })
    },
    getDeletingRFQ1 (data) {
      let { partID, rfqid } = data
      let params = {
        'select': 'id',
        'filter': `rfqid == "${rfqid}" && partID == ${partID}`
      }
      return api
        .get('RFQ1s/GetAllDynamic', { params })
        .then((response) => {
          return response.data.value
        })
    },
    requestDeleteRFQ1 (dataRFQ1) {
      let url = `RFQ1s/Delete/${dataRFQ1.id}`
      return api
        .delete(url)
    }
  }
}
</script>
<style lang="stylus">
  .supplier-quotes-rfq2__list-rfq-2{
    .list-form__header{
      padding-left 0
      padding-right 0
    }
  }
</style>
